import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "services/api";

const columns = [
  {
    field: "Owner",
    headerClassName: "headingbg-color",
    headerName: "Owner",
  },
  {
    field: "Warehouse",
    headerClassName: "headingbg-color",
    headerName: "Warehouse",
  },
  {
    field: "Item",
    headerClassName: "headingbg-color",
    headerName: "Item",
  },
  {
    field: "ItemDescription",
    headerClassName: "headingbg-color",
    headerName: "Item Description",
  },
  {
    field: "Pack",
    headerClassName: "headingbg-color",
    headerName: "Pack",
  },

  {
    field: "BeginCases",
    headerClassName: "headingbg-color",
    headerName: "Starting Cases",
  },
  {
    field: "BeginPcs",
    headerClassName: "headingbg-color",
    headerName: "Starting Pcs",
  },
  {
    field: "ReceivedCases",
    headerClassName: "headingbg-color",
    headerName: "Received Cases",
  },
  {
    field: "ReceivedPcs",
    headerClassName: "headingbg-color",
    headerName: "Received Pcs",
  },
  {
    field: "ShippedCases",
    headerClassName: "headingbg-color",
    headerName: "Shipped Cases",
  },
  {
    field: "ShippedPcs",
    headerClassName: "headingbg-color",
    headerName: "Shipped Pcs",
  },
  {
    field: "AdjustedCases",
    headerClassName: "headingbg-color",
    headerName: "Adjusted Cases",
  },
  {
    field: "AdjustedPcs",
    headerClassName: "headingbg-color",
    headerName: "Adjusted Pcs",
  },
  {
    field: "EndCases",
    headerClassName: "headingbg-color",
    headerName: "End Cases",
  },
  {
    field: "EndPcs",
    headerClassName: "headingbg-color",
    headerName: "End Pcs",
  },
  {
    field: "BeginCBFT",
    headerClassName: "headingbg-color",
    headerName: "Starting CBFT",
  },
  {
    field: "EndCBFT",
    headerClassName: "headingbg-color",
    headerName: "End CBFT",
  },
];

const MonthlyTransactionTable = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = React.useState([]);
  const { startDate, endDate } = props.dateValue
  const { user, userSetting } = useSelector((state) => state.user);

  const fetchTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user?.token}`,
    };
    let payload = {
      custCode: userSetting?.[0]?.currCustomer,
      whseCode: userSetting?.[0]?.currWarehouse,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
    };
    const response = await postRequest(
      "user/getRprt_monthlyItemActivity",
      payload,
      headers
    );
    setData(response.data.Payload);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTableData();
  }, [startDate, endDate, userSetting]);

  const rows = data.map((c, index) => ({
    id: index,
    Owner: c.Owner,
    Warehouse: c.Warehouse,
    Item: c.Item,
    ItemDescription: c.ItemDescription,
    Pack: c.Pack,
    BeginCases: c.BeginCases,
    BeginPcs: c.BeginPcs,
    ReceivedCases: c.ReceivedCases,
    ReceivedPcs: c.ReceivedPcs,
    ShippedCases: c.ShippedCases,
    ShippedPcs: c.ShippedPcs,
    AdjustedCases: c.AdjustedCases,
    AdjustedPcs: c.AdjustedPcs,
    EndCases: c.EndCases,
    EndPcs: c.EndPcs,
    BeginCBFT: c.BeginCBFT,
    EndCBFT: c.EndCBFT
  }));

  return (
    <div
      style={{
        height: 700,
        width: "100%",
        marginTop: "20px",
        background: "#fff",
      }}
    >
      <DataGridPremium
      loading={isLoading}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        columns={columns}
        rows={rows}
        sx={{ flex: 1, "& .MuiButton-text": { fontSize:  "14px"} }}
        pagination
        pageSizeOptions={[30,50, 100, 200]}
        initialState={{pagination: { paginationModel: { pageSize: 50 } }}}
      ></DataGridPremium>
    </div>
  );
};

export default MonthlyTransactionTable;